import * as React from 'react';

import { ActivityInsights } from '~api/activities/insights/insightSchema';
import { translate } from '~l10n/client';
import { SmallButton } from '~shared/components/buttons';
import { useOpenGenerateQuestionsDialog } from '~teacher/components/ResultsGrid/Insights/GenerateQuestions/GenerateQuestionsDialog';
import { sendClickCTAGenerateAIQuestionsInsightsEvent } from '~analytics/index';

import { InsightsLearnMoreLink } from '../InsightsLearnMoreLink';
import { RateInsights } from './RateInsights';

interface InsightsGenerateQuestionsCTAProps {
  insights: ActivityInsights;
  activityInstanceId: number;
}

export function InsightsGenerateQuestionsCTA({
  activityInstanceId,
  insights,
}: InsightsGenerateQuestionsCTAProps) {
  const openGenerateQuestionsDialog = useOpenGenerateQuestionsDialog();

  return (
    <div className="flex items-center justify-between w-full py-4 gap-4">
      <div className="flex items-center gap-4 flex-1">
        <SmallButton
          noWrap
          onClick={() => {
            sendClickCTAGenerateAIQuestionsInsightsEvent();
            openGenerateQuestionsDialog({
              activityInstanceId,
            })
          }}
        >
          {translate('Generate Questions')}
        </SmallButton>
        <div className="text-blue-900 text-base font-400">
          {translate(
            'Turn areas of improvement data into ready-to-use practice questions.'
          )}{' '}
          <InsightsLearnMoreLink subheading="questionsFromInsights" />
        </div>
      </div>
      <div className="flex flex-col items-center gap-3 flex-shrink-0">
        <RateInsights insights={insights} />
      </div>
    </div>
  );
}
